// extracted by mini-css-extract-plugin
export default {"appContainer":"AuthLayout_appContainer__rq4G-"};